import { Checkbox, FormControlLabel } from "@material-ui/core";
import React from "react";

function InputCheck({ label, value, onChange, color = "primary" }) {
  return (
    <FormControlLabel
      control={
        <Checkbox color={color} checked={value} value="" onChange={onChange} />
      }
      label={label}
    />
  );
}

export default InputCheck;
